<template>
  <div>
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>
    <!-- 返回按钮 -->
    <div
      class="topReturnLink w60 fw-600 color0063ea f16 pdb-10 cursor"
      @click="goreturn"
    >
      <i class="el-icon-arrow-left fw-600"></i>
      返回
    </div>

    <!-- 选择 -->
    <div class="flex mgt-30 mgb-50">
      <div
        :class="selectActive == v.id ? 'topselectActive' : 'topselect'"
        v-for="v in select"
        :key="v.id"
        @click="selectBtn(v)"
      >
        {{ v.name }}
      </div>
    </div>

    <!-- 导入 -->
    <div v-if="selectActive == 1">
      <div class="fw-600">批量导入卡</div>
      <div class="color409eff cursor mgt-30" @click="download">
        下载Excle示例
      </div>
      <div class="fw-600 mgt-30 mgb-30">导入Excel</div>
      <el-upload
        ref="upload"
        :action="'#'"
        :limit="1"
        :multiple="false"
        :auto-upload="false"
        accept=".xls,.xlsx"
        :file-list="fileList"
        :http-request="uploadFile"
        :on-change="fileChange"
        :on-exceed="handleExceed"
        :on-remove="handleRemove"
      >
        <el-button size="small" type="primary">文件浏览</el-button>
      </el-upload>
      <el-button
        type="primary"
        class="mgt-30"
        plain
        @click="$refs.upload.submit()"
        >确 定</el-button
      >
    </div>

    <!-- 手动新增 -->
    <div v-if="selectActive == 2">
      <el-button class="mgb-15" type="primary" @click="fenBtn">分配</el-button>
      <!-- 表格 -->
      <el-table
        :data="tableData"
        border
        stripe
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="equipmentNum" label="设备编号">
        </el-table-column>
        <el-table-column prop="name" label="设备名称">
          <template slot-scope="scope">
            <span v-text="scope.row.name ? scope.row.name : '- -'"></span>
          </template>
        </el-table-column>
        <el-table-column prop="equipmentPlace" label="设备地址">
        </el-table-column>
      </el-table>
    </div>

    <!-- 结果表格 -->
    <div class="mgt-200" v-if="resultTable.length > 0">
      <!-- 表格 -->
      <el-table
        max-height="250"
        :data="resultTable"
        border
        stripe
        style="width: 100%"
      >
        <el-table-column
          type="index"
          :index="indexMethod"
          label="序号"
          width="50"
          fixed="left"
        >
        </el-table-column>
        <el-table-column prop="equipmentNum" label="设备编号">
        </el-table-column>
        <el-table-column prop="msg" label="操作结果"> </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
import { handleConfirm, handleAlert } from "../../components/UtilsIf";

export default {
  components: {
    breadcrumbs,
  },
  data() {
    return {
      select: [
        { id: 1, name: "导表分配" },
        { id: 2, name: "手动分配" },
      ],
      selectActive: 1,
      fileList: [], //导入的文件列表
      sourceArr: [],
      guishuList: [],
      userArr: [],
      downUser: "",
      tableData: [],
      multipleSelection: [],
      zoneId: null,
      resultTable: [],
      companyId: null,
    };
  },
  created() {
    this.zoneId = this.$route.query.zoneId;
    this.companyId = this.$route.query.companyId;
  },
  methods: {
    // 手动分配
    fenBtn() {
      if (this.multipleSelection.length === 0) {
        handleAlert("请选择需要分配的设备", "error");
        return;
      }
      let futureEquipmentWaterDtos = [];
      this.multipleSelection.forEach((v) => {
        futureEquipmentWaterDtos.push({
          id: v.id,
          companyName: v.companyName,
          name: v.name,
          equipmentNum: v.equipmentNum,
          equipmentPlace: v.equipmentPlace,
        });
      });
      handleConfirm("确认将设备添加至项目组吗?", "info")
        .then(() => {
          this.$api.zone
            .handBindShebei({
              futureEquipmentWaterDtos: futureEquipmentWaterDtos,
              id: Number(this.zoneId),
            })
            .then((res) => {
              if (res.code === 200) {
                this.getNotList();
                handleAlert("分配成功", "success");
                this.resultTable = res.data;
              }
            });
        })
        .catch(() => {
          return;
        });
    },

    selectBtn(v) {
      this.selectActive = v.id;
      if (this.selectActive === 2) {
        this.getNotList();
      }
    },

    getNotList() {
      this.$api.zone.notShebeiList({ id: this.zoneId }).then((res) => {
        if (res.code === 200) {
          this.tableData = res.data;
        }
      });
    },

    // 导表模板下载
    download() {
      this.$api.zone.shebeiTemplate().then((res) => {
        const link = document.createElement("a");
        link.style.display = "none";
        link.href = URL.createObjectURL(res);
        link.setAttribute("download", "设备分组模板.xls");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    },

    /* 自定义上传 */
    uploadFile(params) {
      // 通过 FormData 对象上传文件
      let formData = new FormData();
      formData.append("file", params.file);

      /* 在这里发请求就行了 */
      /* ------------------------------------ */
      this.$api.zone
        .shebeiUpload({ id: this.zoneId, file: formData })
        .then((res) => {
          if (res.code === 200) {
            //   this.addVisible = false;
            handleAlert("导入成功", "success");
            this.resultTable = res.data;
          }
        });
      /* ------------------------------------ */

      // 成功失败都删除文件;
      this.fileList.splice(-1, 1);
    },
    /* 文件上传后的钩子  在此做校验 */
    fileChange(file, fileList) {
      this.file = file;
      // console.log(fileList);
      this.fileList = fileList;
      console.log(this.fileList, "已上传的");
      console.log(file, fileList, "第一个");
      let extension = file.name.substring(file.name.lastIndexOf(".") + 1);
      if (extension !== "xlsx" && extension !== "xls") {
        this.$message.warning("只能上传后缀是.xlsx和xls的文件");
        fileList.splice(-1, 1); //移除错误文件
        return;
      }
      // 文件大小校验
      const size = file.size / 1024 / 1024;
      if (size > 5) {
        this.$message.warning("文件大小不得超过5M");
        fileList.splice(-1, 1); //移除错误文件
        return;
      }
      this.fileName = file.name;
    },
    /* 超出个数 */
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    // 导入的文件删除
    handleRemove(file, fileList) {
      console.log(file, fileList, "删除");
    },

    // 表格多选发生改变时
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    goreturn() {
      this.$router.push({
        path: "/zoneManage/zoneInfo",
        query: {
          zoneId: this.zoneId,
          companyId: this.companyId,
        },
      });
    },
    //表格序号，根据索引+1
    indexMethod(index) {
      return index + 1;
    },
  },
};
</script>

<style lang="scss" scoped>
.topselect {
  width: 500px;
  height: 30px;
  background: var(--card-bg);
  text-align: center;
  line-height: 30px;
  cursor: pointer;
}
.topselectActive {
  width: 500px;
  height: 30px;
  background: var(--accent);
  color: #fff;
  text-align: center;
  line-height: 30px;
  cursor: pointer;
}
.el-input,
.el-select {
  width: 300px !important;
}
</style>
